import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.css";

const navSections = [
  {
    label: "Overview",
    items: [
      { to: "/", label: "Dashboard", end: true },
      { to: "/analytics", label: "Analytics" },
    ],
  },
  {
    label: "Operations",
    items: [
      { to: "/orders", label: "Orders" },
      { to: "/regions", label: "Regions" },
      { to: "/users", label: "Users" },
      { to: "/customers", label: "Customers" },
      { to: "/vendors", label: "Vendors" },
    ],
  },
  {
    label: "Catalog",
    items: [
      { to: "/catalog", label: "Catalog hub" },
      { to: "/devices", label: "Categories" },
      { to: "/brands", label: "Brands" },
      { to: "/series", label: "Series" },
      { to: "/models", label: "Models" },
    ],
  },
  {
    label: "Assessment",
    items: [
      { to: "/questions", label: "Questions" },
      { to: "/defect-gallery", label: "1. Defect gallery" },
      { to: "/defect-groups", label: "2. Defect groups" },
      { to: "/defects", label: "3. Central defects" },
    ],
  },
  {
    label: "Marketing",
    items: [
      { to: "/promotions/ads", label: "Advertisements" },
      { to: "/promotions/lucky-draws", label: "Scratch cards" },
      { to: "/promotions/coupons", label: "Coupons" },
    ],
  },
  {
    label: "Settings",
    items: [
      { to: "/settings/spotdeal", label: "SpotDeal details" },
      { to: "/policies", label: "Policies" },
      { to: "/policies/vendor-agreement", label: "Vendor agreement" },
    ],
  },
];

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const close = () => setIsOpen(false);

  return (
    <>
      <button
        type="button"
        className="sidebar-toggle"
        onClick={() => setIsOpen((v) => !v)}
        aria-label="Toggle menu"
      >
        ☰
      </button>
      <div
        className={`sidebar-overlay ${isOpen ? "visible" : ""}`}
        onClick={close}
        role="presentation"
      />
      <nav className={`sidebar ${isOpen ? "open" : ""}`} aria-label="Admin navigation">
        <div className="sidebar-brand">
          <div className="sidebar-company">
            <img src="/nexonic-logo.png" alt="Nexonic Etch" className="sidebar-company-logo" />
            <span className="sidebar-company-name">Nexonic Etch</span>
          </div>
          <strong>SpotDeal</strong>
          <span>Admin console</span>
        </div>
        {navSections.map((section) => (
          <div key={section.label} className="sidebar-section">
            <span className="sidebar-section-label">{section.label}</span>
            {section.items.map((item) => (
              <NavLink key={item.to} to={item.to} end={item.end} onClick={close}>
                {item.label}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
    </>
  );
};

export default Sidebar;
